import { render, staticRenderFns } from "./individualPerformance.vue?vue&type=template&id=a35e0d34&scoped=true&"
import script from "./individualPerformance.vue?vue&type=script&lang=js&"
export * from "./individualPerformance.vue?vue&type=script&lang=js&"
import style0 from "./individualPerformance.vue?vue&type=style&index=0&id=a35e0d34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35e0d34",
  null
  
)

export default component.exports